import UploadTab from '../../components/UploadTab';

const UploadPage = () => {
  return <UploadTab />;
};

export default UploadPage;